import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import NotificationBox from '@/components/global/fields/NotificationBox.jsx';

export const ParameterExceptionEmpty = () => {
    const translate = useTranslate();

    return (
        <Box className='parameter-exception-empty'>
            <NotificationBox variant='info' className='large'>
                <Typography variant='body1'>{translate('resources.parameter.labels.noExceptions')}</Typography>
            </NotificationBox>
        </Box>
    );
};
